// Graph counts seed the session. Once read/updated here, stale Graph snapshots
// must not restore that count. This tracks this UI session, not staff on other devices.
export class ChatUnreadTracker {
  private counts = new Map<string, number>();
  private seen = new Set<string>();

  count(id: string, fallback = 0): number {
    return this.counts.get(id) ?? Math.max(0, Number(fallback) || 0);
  }

  read(id: string): void {
    this.counts.set(id, 0);
  }

  receive(pageId: string, messageId: string): boolean {
    if (!messageId) return false;
    const key = `${pageId}:${messageId}`;
    if (this.seen.has(key)) return false;
    this.seen.add(key);
    if (this.seen.size > 5000) this.seen.delete(this.seen.values().next().value!);
    return true;
  }

  increment(id: string, fallback = 0): number {
    const count = this.count(id, fallback) + 1;
    this.counts.set(id, count);
    return count;
  }

  clear(): void {
    this.counts.clear();
    this.seen.clear();
  }
}
